import { PlanFamily, PlanKind } from 'src/types';
import { useSubscriptionInfo, useSubscriptionPlans } from 'src/hooks';
import { OfferCardContent } from 'src/v2/pages/subscription/components/CancelSubscription/components/OfferCardContent';
import styles from './OfferCard.module.scss';
import { PlanCardDescription } from 'src/pages/PaymentBetaPage/componentsV2/PlanCardDescription';
import { OfferCardPrice } from 'src/v2/pages/subscription/components/CancelSubscription/components/OfferCardPrice/OfferCardPrice';
import { OfferCardTitle } from 'src/v2/pages/subscription/components/CancelSubscription/components/OfferCardTitle';
import { NEW_PLANS_VARIANTS } from 'src/constants';
import { PlanCardContent } from 'src/pages/PaymentBetaPage/componentsV2/PlanCardContent';
import { getTotalRecurringPriceLabel } from 'src/utils';
import { UserTier } from 'src/types/wallet/models/UserTier';

type OfferCardProps = {
  onOpenCheckout?: () => void;
  planFamily: PlanFamily;
  planKindToOffer?: PlanKind;
  planTier?: UserTier;
};

export const OfferCard = ({
  planFamily,
  planKindToOffer,
  planTier,
}: OfferCardProps) => {
  // onOpenCheckout is passed-through if needed later
  const { subscriptionInfo } = useSubscriptionInfo();
  const { plans } = useSubscriptionPlans({});
  const planKind = planKindToOffer || PlanKind.STANDARD_MONTHLY;

  const planToOffer = (plans || []).find((item) => item.plan_kind === planKind);

  const finalPriceLabel = getTotalRecurringPriceLabel({
    displayedPlan: planToOffer,
  });

  const variant = planToOffer?.variant;
  const isNewVariant =
    NEW_PLANS_VARIANTS.find((v) => v === variant) !== undefined;

  return (
    <div className={styles.root}>
      <div className={styles.mainContainer}>
        <div className={styles.headerWrapper}>
          <OfferCardTitle planKind={planKind} />

          <OfferCardPrice
            planFamily={planFamily}
            planPrice={finalPriceLabel || subscriptionInfo?.price_info?.amount}
          />

          <PlanCardDescription />
        </div>

        {isNewVariant ? (
          <PlanCardContent
            planFamily={planFamily}
            planKind={planKind}
            planTier={planTier}
          />
        ) : (
          <OfferCardContent
            planFamily={planFamily}
            planKind={planKind}
            isNewVariant={isNewVariant}
          />
        )}
      </div>
    </div>
  );
};
